<template>
<v-flex class="white_background">
    <v-layout row wrap class="member-connections">
        <v-flex xs12 class="member-connections__title">{{memberDirectoryPageConstant.label.MY_FAVORITES_TITLE}}
        </v-flex>
        <v-layout column>
            <v-flex xs12 class="member-connections__tabs">
                <v-layout class="member-connections__tabs-list">
                    <v-flex md3 v-for="(tab, i) in memberConnectionTabs"
                            @click="updateConnectionResult(tab)"
                            :data-qe-id="`member-connections_tab-${i}_link`"
                            class="member-connections__tab"
                            :key="tab.filterKey">
                        <v-tooltip slot="append" top>
                            <span :class="tab.active ? 'member-connections__tab--active' : ''" slot="activator">
                                <span>{{tab.label}}</span>
                                <span class="member-connections__tab-count"
                                       v-if="memberConnection && memberConnection[tab.key]">
                                    ({{memberConnection[tab.key]}})
                                </span>
                            </span>
                            <span>{{tab.toolTip}}</span>
                        </v-tooltip>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 class="member-connections__content">
                <member-directory
                        :persisting-filter-key="appConstant.storageKeys.connectionDirectoryStoredFilters"
                        :no-result-message="currentTab.noResultMessage">
                </member-directory>
            </v-flex>
        </v-layout>
        <hr/>
    </v-layout>
</v-flex>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { memberDirectoryPageConstant, memberConnectionTabs } from '../MemberDirectoryPage/memberDirectoryPage.constants';
    import MemberDirectory from "../MemberDirectoryPage/MemberDirectory";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { appConstant } from "../../app.constant";


    export default {
        name: 'MemberConnectionPage',
        components: {
            MemberDirectory,
        },
        created() {
          this.getMemberConnectionList(this.currentUser);
            if (this.$route.query.additionalFilters) {
                const filterFromRoute = JSON.parse(this.$route.query.additionalFilters);
                if (filterFromRoute) {
                    this.memberConnectionTabs.forEach((item) => {
                        item.active = filterFromRoute.some(it => it.filterKey === item.filterKey);
                    });
                }
            } else {
                this.$router.push({
                    query: {
                        additionalFilters: JSON.stringify([{
                            filterKey: this.memberConnectionTabs[0].filterKey,
                            filterValue: this.currentUser ,
                        }]),
                        filters: sessionStorage.getItem(appConstant.storageKeys.connectionDirectoryStoredFilters),
                    },
                });
            }
        },
        data() {
            return {
                appConstant,
                memberDirectoryPageConstant,
                memberConnectionTabs,
            };
        },
        methods: {
            ...mapActions({
                getMemberConnectionList: `memberDirectory/${storeAction.getMemberConnectionList}`,
            }),
            updateConnectionResult(tab) {
                if (this.memberConnectionTabs) {
                    this.memberConnectionTabs.forEach((item) => {
                        item.active = item.filterKey === tab.filterKey;
                    });
                }
                const activeTab = this.memberConnectionTabs.find(item => item.active);
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        additionalFilters: JSON.stringify([{
                            filterKey: activeTab.filterKey,
                            filterValue: this.currentUser,
                        }]),
                        filters: sessionStorage.getItem(appConstant.storageKeys.connectionDirectoryStoredFilters),
                    },
                });
            },
        },
        computed: {
            ...mapGetters({
                memberConnection: `memberDirectory/${storeGetters.memberConnection}`,
                currentUserId: `auth/${storeGetters.currentUserId}`,
            }),
            currentTab() {
                return this.memberConnectionTabs.find(item => item.active);
            },
            currentUser() {
            return this.currentUserId || "";
          },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/colors';
    @import '../../common/styles/_responsive.scss';

    .member-connections {
        position: relative;
        margin-top: 64px;
        padding: 0 45px;

        @include breakpoint(xs) {
            padding: 0 5px;
        }

        &__title {
            background-color: $white;
            color: $ypo-blue;
            font-family: 'Raleway', sans-serif;
            font-size: 30px;
            font-weight: 500;
            padding: 20px 10px 0 0px;
        }

        &__tabs {
            margin-top: 20px;

            &-list {
                border-bottom: 1px solid $ypo-light-gray;
                margin-bottom: 10px;
            }
        }

        &__tab {
            font-size: 16px;
            line-height: 24px;
            color: $ypo-cta;
            padding-right: 45px;
            cursor: pointer;
            flex: 0 1 auto !important;

            &--active {
                font-weight: 600 !important;
                border-bottom: 2px solid $ypo-gold !important;
            }

            &-count {
                padding-left: 5px;
                padding-right: 5px;
            }
        }
        @media (max-width: 767px){
            margin-top: 55px;
            &__title {
                font-size: 18px;
                padding: 10px 15px 0 15px;
            }
            &__tabs {
                    margin-top: 5px;
                    margin-left: 15px;
            }
            &__tab {
                    font-size: 14px;
                    padding-right: 20px;
            }
        }
    }

</style>


<style lang="scss">
    @import '../../common/styles/colors';
    .member-connections{
.vue-recycle-scroller.ready{
            .vue-recycle-scroller__item-view{
                border-bottom: 1px solid rgba($ypo-gray, 0.2);
           &:hover{
            background: rgba($ypo-cta, 0.09)
        }
            }
    }
    @media (max-width: 1199px) {
            .vue-recycle-scroller.ready {
                .vue-recycle-scroller__item-view {
                    box-shadow: 0 1px 3px 0 rgba($black, 0.18);
                    border: 1px solid rgba($ypo-gray, 0.2) !important;
                    will-change: inherit;
                    border-radius: 4px;
                    background: $white;
                }
            }
            .member-tile{
                min-height: auto;
            }
    }
    }
            
</style>            

